export const RECORDING_REQUEST_MODAL_STAGE = {
  notOpen: 'notOpen',
  moduleDetailStage: 'moduleDetailStage',
  actionStage: 'actionStage',
};
